module.exports = __webpack_public_path__ + "img/copywriting.12c586a3.png";